module.exports = __webpack_public_path__ + "static/img/22.b4cd606.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/22.png
// module id = vjz2
// module chunks = 13